const e = "styles-module__collapsible_container___VMC6U", _ = "styles-module__header___Jr6ya", t = "styles-module__title___T1PiT", l = "styles-module__title_wrapper___bza2a", o = "styles-module__subtitle___625zi", s = "styles-module__arrow_button___Wxg70", n = "styles-module__header_icon___Tlo8v", a = "styles-module__content___AVZty", r = "styles-module__expanded___zRDnz", c = {
  collapsible_container: e,
  header: _,
  title: t,
  title_wrapper: l,
  subtitle: o,
  arrow_button: s,
  header_icon: n,
  content: a,
  expanded: r
};
export {
  s as arrow_button,
  e as collapsible_container,
  a as content,
  c as default,
  r as expanded,
  _ as header,
  n as header_icon,
  o as subtitle,
  t as title,
  l as title_wrapper
};
